define(["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.run = run;
  _exports.name = void 0;
  // @ts-check

  /**
   * This Module adds a metatag description to the document, based on the
   * first paragraph of the abstract.
   */
  const name = "core/seo";
  _exports.name = name;

  function run() {
    // This is not critical, so let's continue other processing first
    (async () => {
      await document.respecIsReady;
      const firstParagraph = document.querySelector("#abstract p:first-of-type");

      if (!firstParagraph) {
        return; // no abstract, so nothing to do
      }

      insertMetaDescription(firstParagraph);
    })();
  }

  function insertMetaDescription(firstParagraph) {
    // Normalize whitespace: trim, remove new lines, tabs, etc.
    const doc = firstParagraph.ownerDocument;
    const content = firstParagraph.textContent.replace(/\s+/, " ").trim();
    const metaElem = doc.createElement("meta");
    metaElem.name = "description";
    metaElem.content = content;
    doc.head.appendChild(metaElem);
  }
});
//# sourceMappingURL=seo.js.map